// extracted by mini-css-extract-plugin
export default {"formContainer":"EditSettingsForm_formContainer__B6a6h","vendorText":"EditSettingsForm_vendorText__l4JDP","submissionButtons":"EditSettingsForm_submissionButtons__jPAdh"};